<osapp-header-modal closeIcon="chevron-back-circle"></osapp-header-modal>

<ion-content class="container">
	<div class="mail-title">
		{{ title }}
	</div>

	<div *ngIf="attachements as attachements" class="attachments">
		<div class="attachements-recap">
			<ion-icon name="attach-outline"></ion-icon>
			<span><strong>{{ attachements.length }}</strong> pièce{{ attachements.length > 1 ? 's' : '' }} jointe{{
				attachements.length > 1 ?
				's' : '' }} ({{ getTotalAttachmentsSize(attachements) }})</span>
		</div>

		<div *ngFor="let attachement of attachements" class="attachment">
			<strong class="ellipsis-fit-content-1">{{ attachement.name }}</strong>
			<span>-</span>
			<span>({{ getAttachmentSize(attachement) }})</span>
		</div>
	</div>


	<div [innerHTML]="message?.body"></div>
</ion-content>